import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import { getSingleOrFamilyText } from "modules/BookingCommon/common/utils/getSingleOrFamily"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

export function getServiceName(serviceGroup: ServicesGroup | undefined, initiator: INITIATOR) {
    if (serviceGroup && serviceGroup.id > 2) {
        return serviceGroup.name
    }
    return getSingleOrFamilyText(!serviceGroup?.family, initiator)
}
